import { getHubspotProvidedNumbers, getHubspotSubAccountNumbers, getConnectAccountNumbers } from '../../callee-omnibus/operators/settingsOmnibusResultGetters';
const getHasTwilioBasedNumbers = ({
  fromNumbers,
  isHubSpotEnabled
}) => {
  var _getHubspotSubAccount, _getHubspotProvidedNu, _getConnectAccountNum;
  return isHubSpotEnabled && (((_getHubspotSubAccount = getHubspotSubAccountNumbers(fromNumbers)) === null || _getHubspotSubAccount === void 0 ? void 0 : _getHubspotSubAccount.size) > 0 || ((_getHubspotProvidedNu = getHubspotProvidedNumbers(fromNumbers)) === null || _getHubspotProvidedNu === void 0 ? void 0 : _getHubspotProvidedNu.size) > 0) || ((_getConnectAccountNum = getConnectAccountNumbers(fromNumbers)) === null || _getConnectAccountNum === void 0 ? void 0 : _getConnectAccountNum.size) > 0;
};
export const getHasMultipleProviders = ({
  installedCallingApplicationsLength,
  fromNumbers,
  isHubSpotEnabled
}) => {
  const hasTwilioBasedNumbers = getHasTwilioBasedNumbers({
    fromNumbers,
    isHubSpotEnabled
  });
  return installedCallingApplicationsLength > 1 || installedCallingApplicationsLength === 1 && hasTwilioBasedNumbers;
};